module.exports = __webpack_public_path__ + "static/img/21.7514ccd9.jpg";